import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Experience } from './components/Experience';
import { WhatHappensHere } from './components/WhatHappensHere';
import { StayOnTheLand } from './components/StayOnTheLand';
import { AboutZev } from './components/AboutZev';
import { LivingFeed } from './components/LivingFeed';
import { TrustDiscovery } from './components/TrustDiscovery';
import { Location } from './components/Location';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    document.title = 'Pines Retreat | Sauna, Ice Baths & Retreat Stay Near Pardes Hanna';
  }, []);
  return <div className="min-h-screen bg-cream text-pine font-sans selection:bg-ember selection:text-cream" data-id="element-0">
      <main className="pb-20 md:pb-0" data-id="element-1">
        <Hero data-id="element-2" />
        <Experience data-id="element-3" />
        <WhatHappensHere data-id="element-4" />
        <StayOnTheLand data-id="element-5" />
        <AboutZev data-id="element-6" />
        <LivingFeed data-id="element-7" />
        <TrustDiscovery data-id="element-8" />
        <Location data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <StickyCTA data-id="element-12" />
    </div>;
}